import { API } from 'aws-amplify';
import { useQuery } from '@tanstack/react-query';
import { listProducts } from '../../../../graphql/queries';
import { Product } from './types';

const fetchProducts = async (): Promise<Partial<Product>[]> => {
  let productList: Partial<Product>[] = [];
  let nextToken: string | null = null;
  do {
    const res: any = await API.graphql({
      query: listProducts,
      variables: {
        limit: 1000,
        filter: {
          isDeleted: { ne: true },
          // @ts-ignore
          orgID: { eq: global.me.orgID },
        },
        nextToken,
      },
    });
    productList = [...productList, ...(res.data?.listProducts?.items ?? [])];
    nextToken = res.data?.listProducts?.nextToken;
  } while (nextToken);

  // @ts-ignore
  const unsortedProducts = productList || [];
  return (
    unsortedProducts
      .slice()
      // @ts-ignore
      .sort((a: Product, b: Product) =>
        a.name && b.name ? a.name.localeCompare(b.name) : 0
      )
  );
};

export const useGetProducts = () => {
  return useQuery({
    queryKey: ['products'],
    queryFn: fetchProducts,
  });
};
